<!--临时客商新增  -->
<template>
	<div class="info-box">
		<el-dialog
			title="巡回计划信息"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="1000px"
			:before-close="cancle"
			top="3vh">
			<div class="info-title flex flex-between">
				<div class="lh30">基础信息:</div>
				<div class="flex">
					<el-button size="small" type="primary" @click="submitForm('ruleForm')" v-if="rowData.planStatus <= 0">保存</el-button>
				</div>
			</div>
			<!--  -->
			<div class="form-box mt15">
				<el-form label-position="right" :inline="true" size="small" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
					<el-form-item label="计划编号" prop="planCode">
						<el-input v-model="dataForm.planCode" class="w205" maxlength="16" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="路线名称" prop="routeName">
						<el-input v-model="dataForm.routeName" class="w205" maxlength="16" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="计划日期" prop="planDate">
						<el-date-picker
							class="w205"
							v-model="dataForm.planDate"
							value-format="yyyy-MM-dd"
							:disabled="rowData.planStatus > 0 ? true : false"
							:picker-options="pickerOptions"
							type="date"
							placeholder="选择日期"></el-date-picker>
					</el-form-item>

					<el-form-item label="主路线员" prop="mainUserCode">
						<el-input v-model="dataForm.mainUserCode" class="w120" maxlength="16" readonly :disabled="rowData.planStatus > 0 ? true : false">
							<i
								slot="suffix"
								:class="rowData.planStatus > 0 ? 'nonallowed' : ''"
								@click="handleRouteUser(1)"
								class="el-input__icon el-icon-search"></i>
						</el-input>
						<el-input v-model="dataForm.mainUserName" class="w80 ml5" maxlength="16" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="副路线员" prop="secUserCode">
						<el-input v-model="dataForm.secUserCode" class="w120" maxlength="16" readonly :disabled="rowData.planStatus > 0 ? true : false">
							<i
								slot="suffix"
								:class="rowData.planStatus > 0 ? 'nonallowed' : ''"
								@click="handleRouteUser(2)"
								class="el-input__icon el-icon-search"></i>
							<i slot="suffix" v-if="dataForm.secUserCode" @click="handleClear" class="el-input__icon el-icon-circle-close"></i>
						</el-input>
						<el-input v-model="dataForm.secUserName" class="w80 ml5" maxlength="16" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="配送车辆" prop="licensePlate">
						<el-input v-model="dataForm.licensePlate" class="w205" maxlength="16" readonly :disabled="rowData.planStatus > 0 ? true : false">
							<i slot="suffix" :class="rowData.planStatus > 0 ? 'nonallowed' : ''" @click="handleCar" class="el-input__icon el-icon-search"></i>
						</el-input>
					</el-form-item>
					<el-form-item label="出车时间">
						<el-date-picker class="w205" v-model="dataForm.drawOutTime" type="datetime" :disabled="true" placeholder="选择日期"></el-date-picker>
					</el-form-item>
					<el-form-item label="回车时间">
						<el-date-picker class="w205" v-model="dataForm.returnTime" type="datetime" :disabled="true" placeholder="选择日期"></el-date-picker>
					</el-form-item>
					<el-form-item label="临时计划" prop="tempFlag">
						<el-select v-model="dataForm.tempFlag" class="w205" size="small" placeholder="选择" :disabled="rowData.planStatus > 0 ? true : false">
							<el-option label="否" value="0"></el-option>
							<el-option label="是" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div>
				<div class="info-title flex flex-between">
					<div class="lh30">客商列表:</div>
					<div class="flex">
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="deleteRow" title="删除" alt="" />
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="" />
					</div>
				</div>
				<el-table
					class="mt20"
					:data="tableData"
					v-if="tableData.length > 0"
					ref="multipleTable"
					:header-cell-style="{ background: '#C8CCD7', color: '#333333', height: '25px' }"
					:cell-style="cellStyle"
					v-el-table-infinite-scroll="tableLoad"
					@selection-change="handleSelectionChange"
					@cell-click="editRow"
					border
					height="50vh"
					style="width: 100%">
					<el-table-column prop="deliverSort" width="60" label="序号" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column type="selection" width="50" align="center"></el-table-column>
					<el-table-column prop="agentName" label="客商简称" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="arrivalTime" width="200" label="到店时间" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="leaveTime" width="200" label="离店时间" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column label="调序" :show-overflow-tooltip="true" width="120">
						<template slot-scope="scope">
							<i class="el-icon-bottom ml15 opeartion" @click="sortDown(scope.row, 2)" v-if="scope.$index + 1 != tableData.length"></i>
							<i class="el-icon-top ml15 opeartion" @click="sortDown(scope.row, 1)" v-if="scope.$index > 0"></i>
						</template>
					</el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
			</div>
		</el-dialog>
		<addMerchants ref="addMerchants" @getAgentList="getInfo"></addMerchants>
		<addCar ref="addCar" @selectCarRows="selectCarRows"></addCar>
		<sortEdit ref="sortEdit" @getList="getInfo"></sortEdit>
		<addRouteUser ref="addRouteUser" @selectUserRows="selectUserRows" @flag="flag" @clearReadonly="clearReadonly"></addRouteUser>
	</div>
</template>

<script>
import { debounce } from "@/utils/debounce";
import addMerchants from "./add-merchants.vue";
import addCar from "./add-car.vue";
import addRouteUser from "./add-route-user.vue";
import sortEdit from "./sort-edit.vue";
export default {
	components: {
		addMerchants,
		addCar,
		addRouteUser,
		sortEdit,
	},
	data() {
		return {
			dialogVisible: false,
			pickerOptions: {
				disabledDate(v) {
					return v.getTime() < new Date().getTime() - 86400000;
				},
			},
			groupDate: [],
			dataForm: {
				planId: "",
				planCode: "",
				planDate: "",
				routeId: "",
				routeName: "",
				groupId: "",
				licensePlate: "",
				routeStatus: "",
				mainUserCode: "",
				secUserCode: "",
				mainUserName: "",
				secUserName: "",
				drawOutTime: "",
				returnTime: "",
				tempFlag: "0", // 临时计划
			},
			rules: {
				planCode: [
					{
						required: true,
						message: "计划编号不能为空",
						trigger: "blur",
					},
				],
				planDate: [
					{
						required: true,
						message: "请选择计划日期",
						trigger: "change",
					},
				],
				routeName: [
					{
						required: true,
						message: "请输入路线名称",
						trigger: "blur",
					},
				],
				licensePlate: [
					{
						required: true,
						message: "请选择配送车辆",
						trigger: "change",
					},
				],
				mainUserCode: [
					{
						required: true,
						message: "请选择主路线员",
						trigger: "change",
					},
				],
			},
			roundAgentList: [],
			skuList: [],
			rowData: {},
			codeList: [],
			tableData: [],
			titles: [],
			flagRow: [],
			pageNo: 1,
			pageSize: 10,
			multipleTable: [],
			secFlag: false,
		};
	},
	created() {},
	methods: {
		cellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 0) {
				return "cursor: pointer;";
			}
		},
		init(data) {
			this.dialogVisible = true;
			this.$nextTick(() => {
				this.rowData = {};
				this.pageNo = 1;
				// this.getBusSelectList()
				this.roundAgentList = [];
				this.dataForm = {
					planCode: "",
					planDate: "",
					planId: "",
					routeId: "",
					routeName: "",
					groupId: "",
					licensePlate: "",
					routeStatus: "",
					deliveryCycle: "",
					mainUserCode: "",
					secUserCode: "",
					mainUserName: "",
					secUserName: "",
					carId: "",
					drawOutTime: "",
					returnTime: "",
					tempFlag: "0", // 临时计划
				};
				if (data) {
					this.rowData = data;
					this.getInfo();
					// this.getRouteAgent()
				}
			});
		},
		// 查询
		getInfo() {
			let that = this;
			that.$request
				.post("roundPlanInfo", true, {
					planId: that.rowData.planId,
				})
				.then((res) => {
					if (res) {
						that.dataForm = {
							planCode: res.data.planCode,
							planDate: res.data.planDate,
							mainUserId: res.data.mainUserId,
							secUserId: res.data.secUserId,
							planId: res.data.planId,
							groupId: res.data.groupId,
							routeName: res.data.routeName,
							licensePlate: res.data.licensePlate,
							carId: res.data.carId,
							mainUserCode: res.data.mainUserCode,
							secUserCode: res.data.secUserCode,
							mainUserName: res.data.mainUserName,
							secUserName: res.data.secUserName,
							routeId: that.dataForm.routeId,
							drawOutTime: res.data.drawOutTime,
							returnTime: res.data.returnTime,
							tempFlag: String(res.data.tempFlag) || "0", // 临时计划
						};
						that.tableData = res.data.roundAgent;
					}
				});
		},
		//  添加客商信息
		handleAddMerge(val) {
			if (val == 1 && this.tableData.length >= 10) {
				this.$message.error("只能添加10条源客商!");
				return;
			}
			this.$refs.addMerchants.init(this.tableData);
		},
		// 选择的车辆信息
		selectCarRows(val) {
			this.dataForm.licensePlate = val[0].licensePlate;
			this.dataForm.carId = val[0].carId;
		},
		//  添加线路员类型
		flag(val) {
			if (val == 1) {
				this.dataForm.mainUserCode = this.flagRow[0].datas[1];
				this.dataForm.mainUserName = this.flagRow[0].datas[0];
			} else {
				this.dataForm.secUserCode = this.flagRow[0].datas[1];
				this.dataForm.secUserName = this.flagRow[0].datas[0];
			}
		},
		// 添加线路员
		selectUserRows(val) {
			this.flagRow = val;
		},
		//  添加客商
		selectRows(val) {
			this.pageNo = 1;
			this.getRouteAgent();
			if (this.tableData.length > 0) {
				this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
			}
		},
		//添加线路成员
		handleRouteUser(val) {
			if (val == 2) {
				this.secFlag = true;
			}
			this.$refs.addRouteUser.init(val, this.dataForm);
		},
		// 清除副路线员readonly状态
		clearReadonly() {
			this.secFlag = false;
		},
		// 清除副路线员
		handleClear() {
			this.dataForm.secUserCode = "";
			this.dataForm.secUserName = "";
		},
		// 添加车辆
		handleCar() {
			this.$refs.addCar.init(this.dataForm);
		},
		// 新增客商
		handleEdit() {
			this.$refs.addMerchants.init(this.dataForm.planId, this.dataForm.groupId);
		},
		// 查看/编辑
		editRow(row, column, cell, event) {
			if (column.label == "序号") {
				this.$refs.sortEdit.init(row);
			}
		},
		// 列多选
		handleSelectionChange(val) {
			this.multipleTable = val;
		},
		// 删除
		deleteRow() {
			let that = this;
			if (that.multipleTable.length <= 0) {
				that.$message.error("请先选择!");
				return;
			}
			let recordIds = [];
			that.multipleTable.forEach((item) => {
				recordIds.push(item.recordId);
			});
			that.$confirm("是否确认删除？", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "error",
			})
				.then(() => {
					that.$request
						.post("deleteAgent", true, {
							planId: that.dataForm.planId,
							recordIds: recordIds,
						})
						.then((res) => {
							if (res) {
								that.$message.success("删除成功！");
								that.pageNo = 1;
								that.getInfo();
							}
						});
				})
				.catch(() => {});
		},

		// 表格滚动加载
		tableLoad: debounce(
			function () {
				this.pageNo++;
				// this.getRouteAgent('scroll');
			},
			100,
			true,
		),
		// 客商路线列表
		getRouteAgent(type) {
			let that = this;
			that.$request
				.post("routeAgent", false, {
					routeId: that.dataForm.routeId,
					pageNo: that.pageNo,
					pageSize: that.pageSize,
				})
				.then((res) => {
					if (type == "scroll") {
						that.tableData = that.tableData.concat((res.data && res.data.tableDatas) || []);
					} else {
						if (res.data && res.data.tableDatas.length > 0) {
							that.titles = res.data.titles;
							that.tableData = res.data.tableDatas;
						} else {
							that.titles = [];
							that.tableData = [];
						}
					}
				});
		},
		// 组织部门
		getBusSelectList() {
			let that = this;
			that.$request.post("busSelectList", false, {}).then((res) => {
				if (res) {
					that.groupDate = res.data;
				}
			});
		},
		// 上移下移
		sortDown(row, val) {
			let that = this;
			that.$request
				.post("roundPlanSort", false, {
					recordId: row.recordId,
					removeFlag: val,
				})
				.then((res) => {
					if (res) {
						that.$message.success(val == 1 ? "上移成功！" : "下移成功！");
						that.getInfo();
					}
				});
		},

		// 保存
		submitForm: debounce(
			function () {
				this.$refs["dataForm"].validate((valid) => {
					if (valid) {
						if (this.dataForm.mainUserCode == this.dataForm.secUserCode) {
							this.$message.error("主路线员和副路线员不能一致!");
							return;
						}
						let msg = ""
						if (this.dataForm.tempFlag == "1") {
							msg = "是否确认保存？<span style='color: red;'>是否将此计划设为临时计划？</span>";
	  					}else {
							msg = "是否确认保存？";
						}
						this.$confirm(msg, {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							dangerouslyUseHTMLString: true,
						})
							.then(() => {
								this.updateRow();
							})
							.catch(() => {});
					} else {
						return false;
					}
				});
			},
			1000,
			true,
		),
		// 修改
		updateRow() {
			let that = this;
			that.$request
				.post("roundPlanUpdate", true, {
					planId: that.dataForm.planId,
					groupId: that.dataForm.groupId,
					routeId: that.dataForm.routeId,
					routeName: that.dataForm.routeName,
					licensePlate: that.dataForm.licensePlate,
					routeStatus: that.dataForm.routeStatus,
					deliveryCycle: that.dataForm.deliveryCycle,
					mainUserCode: that.dataForm.mainUserCode,
					secUserCode: that.dataForm.secUserCode,
					mainUserName: that.dataForm.mainUserName,
					secUserName: that.dataForm.secUserName,
					carId: that.dataForm.carId,
					planDate: that.dataForm.planDate,
					tempFlag: that.dataForm.tempFlag,
				})
				.then((res) => {
					if (res) {
						that.dialogVisible = false;
						that.$message.success("保存成功！");
						that.$emit("getList");
					}
				});
		},
		// 取消
		cancle() {
			this.dialogVisible = false;
			this.$refs["dataForm"].resetFields();
			this.$emit("getList");
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.mb0 {
	margin-bottom: 0 !important;
}

.w90 {
	width: 110px;
}

.nc-box {
	padding: 10px;
	border-bottom: 1px solid #dcdfe6;
	color: #606266;
	font-size: 13px;
}

.mb10 {
	margin-bottom: 10px !important;
}

.w205 {
	width: 205px;
}

.info-box {
	/deep/ .el-dialog__body {
		// height: 420px;
		padding: 20px 20px 10px;
		overflow-y: auto;
	}
}

.info-title {
	background: #e5e5e5;
	color: #333;
	padding: 10px;
	box-sizing: border-box;
	font-size: 16px;
	font-weight: bold;

	img {
		vertical-align: bottom;
		display: block;
	}
}

.el-form-item {
	width: 320px;
	margin-right: 0;
}

.w330 {
	width: 330px;
}

.w420 {
	width: 420px !important;
	margin-right: 10px;
}

.info-name {
	display: inline-block;
	width: 140px;
	text-align: right;
}

.opeartion {
	font-size: 18px;
	cursor: pointer;
}

.lh30 {
	line-height: 30px;
}

.el-table {
	// 深度选择器，去除默认的padding
	/deep/ th {
		padding: 5px;
	}

	/deep/ td {
		padding: 5px;
	}
}
.el-icon-search {
	cursor: pointer;
}
.el-icon-circle-close {
	cursor: pointer;
}
.nonallowed {
	pointer-events: none;
}

.w120 {
	width: 120px;
}

.w80 {
	width: 80px;
}

.ml5 {
	margin-left: 5px;
}
</style>
<style>
.el-table-column--selection .cell {
	padding: 0;
}
</style>
